import { useEffect, useState } from "react";
import { ScrollText, ChevronDown, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const LABELS = {
  "user.update": "Updated account", "user.password": "Set new password", "user.delete": "Deleted account",
  "settings.signups": "Sign-ups", "invite.create": "Created invite", "invite.revoke": "Revoked invite",
};
const fmt = (d) => new Date(d).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
const describe = (e) => {
  const d = e.details || {};
  if (e.action === "user.update") return Object.entries(d).map(([k, v]) => `${k.replace(/_/g, " ")} → ${String(v)}`).join(", ");
  if (e.action === "invite.create") return `${d.library_access}${d.storage_limit_mb ? ` · ${d.storage_limit_mb} MB` : ""}`;
  return "";
};

export const AuditLog = () => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);
  useEffect(() => { if (open && rows === null) api.get("/admin/audit").then((r) => setRows(r.data)).catch(() => setRows([])); }, [open, rows]);
  return (
    <section className="mb-8 rounded-lg border border-zinc-200 bg-white" data-testid="audit-section">
      <button onClick={() => setOpen((o) => !o)} data-testid="audit-toggle" aria-expanded={open} className="flex w-full items-center gap-3 p-6 text-left">
        <div className="flex h-10 w-10 items-center justify-center rounded-md bg-zinc-100 text-zinc-700"><ScrollText size={18} /></div>
        <div className="flex-1">
          <h2 className="font-medium">Activity log</h2>
          <p className="text-xs text-zinc-500">Who changed what: roles, access, passwords, deletions, invites.</p>
        </div>
        <ChevronDown size={16} className={`text-zinc-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="border-t border-zinc-100 px-6 pb-5" data-testid="audit-list">
          {rows === null ? <Loader2 className="mt-4 animate-spin text-zinc-400" /> : rows.length === 0 ? <p className="py-4 text-xs text-zinc-500" data-testid="audit-empty">No admin actions recorded yet.</p> : (
            <ul className="divide-y divide-zinc-100">
              {rows.map((e, i) => (
                <li key={`${e.at}-${i}`} className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5 py-2 text-xs" data-testid={`audit-row-${i}`}>
                  <span className="w-32 shrink-0 font-mono text-[10px] text-zinc-400">{fmt(e.at)}</span>
                  <span className="font-medium text-zinc-800">{LABELS[e.action] || e.action}</span>
                  <span className="font-mono text-zinc-600">{e.target}</span>
                  {describe(e) && <span className="text-zinc-500">{describe(e)}</span>}
                  <span className="ml-auto font-mono text-[10px] text-zinc-400">by {e.actor_email}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </section>
  );
};
